
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_9dpc0_9",
  "child": "awsui_child_18582_9dpc0_13",
  "horizontal": "awsui_horizontal_18582_9dpc0_24",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_9dpc0_28",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_9dpc0_31",
  "horizontal-xs": "awsui_horizontal-xs_18582_9dpc0_34",
  "horizontal-s": "awsui_horizontal-s_18582_9dpc0_37",
  "horizontal-m": "awsui_horizontal-m_18582_9dpc0_40",
  "horizontal-l": "awsui_horizontal-l_18582_9dpc0_43",
  "horizontal-xl": "awsui_horizontal-xl_18582_9dpc0_46",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_9dpc0_49",
  "vertical": "awsui_vertical_18582_9dpc0_56",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_9dpc0_59",
  "vertical-xxs": "awsui_vertical-xxs_18582_9dpc0_62",
  "vertical-xs": "awsui_vertical-xs_18582_9dpc0_65",
  "vertical-s": "awsui_vertical-s_18582_9dpc0_68",
  "vertical-m": "awsui_vertical-m_18582_9dpc0_71",
  "vertical-l": "awsui_vertical-l_18582_9dpc0_74",
  "vertical-xl": "awsui_vertical-xl_18582_9dpc0_77",
  "vertical-xxl": "awsui_vertical-xxl_18582_9dpc0_80",
  "align-center": "awsui_align-center_18582_9dpc0_84",
  "align-start": "awsui_align-start_18582_9dpc0_88",
  "align-end": "awsui_align-end_18582_9dpc0_92",
  "child-aligned": "awsui_child-aligned_18582_9dpc0_96"
};
  